// extracted by mini-css-extract-plugin
export default {"style":"Clock_style__xKZhY"};